import React from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";

function Login() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  const handleGoogleSignin = async () => {
    try {
      await loginWithGoogle();
      navigate("/");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left panel — branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-slate-900 flex-col justify-between p-12">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/asia-robotica.appspot.com/o/Logos%2Flogo_asiarob.png?alt=media&token=15bbab76-4990-4bbb-8ba8-4f0fdda52bfb"
          alt="Logo"
          className="h-10 w-fit brightness-0 invert"
        />
        <div>
          <h1 className="text-4xl font-bold text-white leading-tight mb-4">
            Plataforma de Asignación<br />de Servicios
          </h1>
          <p className="text-slate-400 text-lg max-w-md">
            Gestiona tus tickets, técnicos e itinerarios de servicio desde un solo lugar.
          </p>
        </div>
        <p className="text-slate-500 text-sm">
          © {new Date().getFullYear()} Asia Robótica. Todos los derechos reservados.
        </p>
      </div>

      {/* Right panel — login form */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 bg-white">
        {/* Mobile logo */}
        <img
          src="https://firebasestorage.googleapis.com/v0/b/asia-robotica.appspot.com/o/Logos%2Flogo_asiarob.png?alt=media&token=15bbab76-4990-4bbb-8ba8-4f0fdda52bfb"
          alt="Logo"
          className="lg:hidden h-8 mb-10"
        />

        <div className="w-full max-w-sm">
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Bienvenido</h2>
          <p className="text-slate-500 mb-8">Inicia sesión para acceder a la plataforma</p>

          <button
            onClick={handleGoogleSignin}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-lg border border-slate-300
                       text-sm font-semibold text-slate-700 bg-white
                       hover:bg-slate-50 hover:border-slate-400 active:bg-slate-100
                       transition-all duration-150 shadow-sm"
          >
            <FcGoogle className="w-5 h-5" />
            Continuar con Google
          </button>

          <div className="relative my-8">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-slate-200" />
            </div>
            <div className="relative flex justify-center">
              <span className="bg-white px-3 text-sm text-slate-400">o</span>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="label">Correo electrónico</label>
              <input
                type="email"
                placeholder="nombre@empresa.com"
                className="input"
              />
            </div>
            <button className="btn-primary w-full py-3">
              Continuar
            </button>
          </div>

          <p className="mt-8 text-center text-xs text-slate-400 leading-relaxed">
            Al continuar, aceptas nuestros términos de servicio y política de privacidad.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
